__turbopack_context__.v({
  "ctaWrapper": "CardDownload-module-scss-module__InWzrG__ctaWrapper",
  "downloadCard": "CardDownload-module-scss-module__InWzrG__downloadCard",
  "downloadCardInner": "CardDownload-module-scss-module__InWzrG__downloadCardInner",
  "fade-in": "CardDownload-module-scss-module__InWzrG__fade-in",
  "headline": "CardDownload-module-scss-module__InWzrG__headline",
  "image": "CardDownload-module-scss-module__InWzrG__image",
  "imageWrapper": "CardDownload-module-scss-module__InWzrG__imageWrapper",
  "lockUp": "CardDownload-module-scss-module__InWzrG__lockUp",
});
